/**
 * @generated SignedSource<<19ea5a313f5a5d4386e252d17e3db76b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentNotificationEmailCtaButton = "disabled" | "enabled" | "%future added value";
export type EventVisibility = "cohort" | "member_group" | "public" | "%future added value";
export type MemberGroupKind = "custom" | "default" | "role" | "test_user" | "%future added value";
export type OccurrenceReminderAudience = "all" | "non_rsvps" | "rsvps" | "%future added value";
export type OccurrenceStatus = "draft" | "published" | "%future added value";
export type OccurrenceZoomMeetingStatus = "current" | "failed" | "past" | "upcoming" | "%future added value";
export type ProductType = "community_event" | "course" | "membership_plan" | "pathway" | "%future added value";
export type WebFormQuestionType = "link" | "multiple_select" | "ranking" | "rating" | "single_select" | "written_answer" | "%future added value";
export type ZoomConnectionHumanReadableUserPlanType = "basic" | "licensed" | "none" | "premium" | "unknown" | "%future added value";
export type EditEventInput = {
  allowGuestAccess?: boolean | null;
  capacity?: number | null;
  collectFeedback?: boolean | null;
  content?: EditContentInput | null;
  datetimeRange?: ReadonlyArray<string> | null;
  guestCapacity?: number | null;
  hosts?: ReadonlyArray<OccurrenceHostInput> | null;
  initialMemberGroupIds?: ReadonlyArray<string> | null;
  meetingProviderId?: string | null;
  meetingUrl?: string | null;
  memberGroupIdsToAdd?: ReadonlyArray<string> | null;
  memberGroupIdsToRemove?: ReadonlyArray<string> | null;
  notificationEmailBody?: string | null;
  notifyMembersOnChange?: boolean | null;
  occurrenceId: string;
  physicalAddress?: GoogleMapAddressComponents | null;
  reminders?: ReadonlyArray<OccurrenceReminderInput> | null;
  status?: OccurrenceStatus | null;
  timezone?: string | null;
  videoRoomType?: string | null;
  visibility?: EventVisibility | null;
  zoomMeetingId?: string | null;
  zoomMeetingType?: number | null;
};
export type GoogleMapAddressComponents = {
  address: string;
  displayAddress?: string | null;
  image?: string | null;
  lat: number;
  lng: number;
  name?: string | null;
  placeId: string;
};
export type EditContentInput = {
  attachments?: ReadonlyArray<ContentAttachmentInput> | null;
  contentLabelId?: string | null;
  coverAudio?: string | null;
  coverAudioAssetId?: string | null;
  coverPhoto?: string | null;
  coverPhotoAssetId?: string | null;
  coverVideo?: string | null;
  coverVideoAssetId?: string | null;
  coverVideoDurationSeconds?: number | null;
  ctaAppId?: string | null;
  ctaText?: string | null;
  description?: string | null;
  isAiGenerated?: boolean | null;
  name?: string | null;
  notificationEmailCtaButton?: ContentNotificationEmailCtaButton | null;
  notificationEmailSubject?: string | null;
  releaseDatetime?: string | null;
  releaseNow?: boolean | null;
  richEditorDescriptionContent?: string | null;
  richEditorNotificationEmailBodyContent?: string | null;
  sendNotificationEmail?: boolean | null;
  showComments?: boolean | null;
  showCoverPlayIcon?: boolean | null;
  submissionLink?: string | null;
  thumbnailAssetId?: string | null;
  thumbnailUrl?: string | null;
  timeEstimateMinutes?: number | null;
  webFormRevision?: CreateWebFormRevisionInput | null;
};
export type ContentAttachmentInput = {
  id?: string | null;
  mediaAssetId?: string | null;
  mediaUrl?: string | null;
  name?: string | null;
};
export type CreateWebFormRevisionInput = {
  contentUsageId?: string | null;
  questions: ReadonlyArray<WebFormQuestionInput>;
  webFormId: string;
};
export type WebFormQuestionInput = {
  answerKey?: WebFormQuestionAnswerKeyInput | null;
  isRequired?: boolean | null;
  options?: ReadonlyArray<WebFormQuestionOptionInput> | null;
  richEditorBody: string;
  type: WebFormQuestionType;
};
export type WebFormQuestionOptionInput = {
  id: string;
  label: string;
};
export type WebFormQuestionAnswerKeyInput = {
  correctIds: ReadonlyArray<string>;
  feedback?: string | null;
};
export type OccurrenceHostInput = {
  organizationMembershipId?: string | null;
  productMembershipId?: string | null;
};
export type OccurrenceReminderInput = {
  audience: OccurrenceReminderAudience;
  emailRichEditorBody: string;
  emailSubject: string;
  id?: string | null;
  timing: string;
};
export type EditEventDrawerContextMutation$variables = {
  input: EditEventInput;
};
export type EditEventDrawerContextMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly allRsvps: {
        readonly totalCount: number;
      } | null;
      readonly allowGuestAccess: boolean;
      readonly app: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"EventAccessFormFields_AppFragment">;
      } | null;
      readonly capacity: number | null;
      readonly collectFeedback: boolean;
      readonly content: {
        readonly attachments: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly mediaUrl: string | null;
              readonly name: string;
            };
          }>;
        };
        readonly coverPhoto: string | null;
        readonly name: string | null;
        readonly richEditorDescriptionContent: string | null;
      };
      readonly coverPhoto: string | null;
      readonly datetimeRange: ReadonlyArray<string>;
      readonly event: {
        readonly id: string;
        readonly isRecurring: boolean;
        readonly memberGroupEntityTargets: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly memberGroup: {
                readonly id: string;
                readonly kind: MemberGroupKind;
              } | null;
            };
          }>;
        };
        readonly productId: string;
        readonly " $fragmentSpreads": FragmentRefs<"MemberGroupEventTagListFragment">;
      };
      readonly guestCapacity: number | null;
      readonly hosts: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly organizationMembershipId: string;
            readonly productMembershipId: string | null;
            readonly user: {
              readonly avatar: string;
              readonly first_name: string | null;
              readonly id: string;
              readonly last_name: string | null;
            };
          };
        }>;
        readonly totalCount: number;
      };
      readonly id: string;
      readonly media: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          };
        }>;
      } | null;
      readonly meetingProvider: {
        readonly id: string;
        readonly organization: {
          readonly hasZoomIntegration: boolean;
          readonly id: string;
        };
        readonly user: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"ProfileAvatarWithDetailsFragment">;
        };
        readonly zoomConnection: {
          readonly email: string | null;
          readonly firstName: string | null;
          readonly hasWebinarAddon: boolean | null;
          readonly id: string;
          readonly isConnected: boolean;
          readonly lastName: string | null;
          readonly meetingCapacity: number | null;
          readonly picUrl: string | null;
          readonly userPlanType: ZoomConnectionHumanReadableUserPlanType;
          readonly webinarCapacity: number | null;
        };
        readonly " $fragmentSpreads": FragmentRefs<"OrganizationZoomConnectionListItemFragment">;
      } | null;
      readonly meetingUrl: string | null;
      readonly name: string | null;
      readonly physicalAddress: {
        readonly address: string;
        readonly displayAddress: string;
        readonly image: string;
        readonly lat: number;
        readonly lng: number;
        readonly placeId: string;
      } | null;
      readonly product: {
        readonly id: string;
        readonly organization: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"EventAccessFormFields_OrganizationFragment" | "EventMeetingFormFields_OrganizationFragment">;
        };
        readonly type: ProductType;
        readonly " $fragmentSpreads": FragmentRefs<"EventAccessFormFields_ProductFragment" | "EventMeetingFormFields_ProductFragment">;
      };
      readonly reminders: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly audience: OccurrenceReminderAudience;
            readonly emailRichEditorBody: string;
            readonly emailSubject: string;
            readonly id: string;
            readonly sentAt: string | null;
            readonly timing: string;
          };
        }>;
      } | null;
      readonly richEditorDescriptionContent: string | null;
      readonly status: OccurrenceStatus;
      readonly timezone: string;
      readonly videoRoomType: string;
      readonly visibility: EventVisibility;
      readonly zoomRecurringMeetingStatus: OccurrenceZoomMeetingStatus | null;
      readonly " $fragmentSpreads": FragmentRefs<"OccurrenceListItemFragment">;
    } | null;
  };
};
export type EditEventDrawerContextMutation = {
  response: EditEventDrawerContextMutation$data;
  variables: EditEventDrawerContextMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coverPhoto",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "richEditorDescriptionContent",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "ContentAttachmentNodeConnection",
  "kind": "LinkedField",
  "name": "attachments",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentAttachmentNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentAttachment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mediaUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v8 = [
  (v2/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowGuestAccess",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "collectFeedback",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "capacity",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guestCapacity",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingUrl",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "videoRoomType",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "ZoomConnection",
  "kind": "LinkedField",
  "name": "zoomConnection",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "picUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userPlanType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasWebinarAddon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingCapacity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "webinarCapacity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isConnected",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasZoomIntegration",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomRecurringMeetingStatus",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "EventPhysicalAddress",
  "kind": "LinkedField",
  "name": "physicalAddress",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lat",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lng",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "placeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberGroupEntityTargetNodeConnection",
  "kind": "LinkedField",
  "name": "memberGroupEntityTargets",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MemberGroupEntityTargetNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MemberGroupEntityTarget",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "MemberGroup",
              "kind": "LinkedField",
              "name": "memberGroup",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                (v23/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRecurring",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatar",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "OccurrenceHostNodeConnection",
  "kind": "LinkedField",
  "name": "hosts",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "OccurrenceHostNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OccurrenceHost",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "alias": "first_name",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": "last_name",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                (v27/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "productMembershipId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "organizationMembershipId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "datetimeRange",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timezone",
  "storageKey": null
},
v31 = [
  (v26/*: any*/)
],
v32 = {
  "alias": "allRsvps",
  "args": null,
  "concreteType": "OccurrenceRSVPNodeConnection",
  "kind": "LinkedField",
  "name": "rsvps",
  "plural": false,
  "selections": (v31/*: any*/),
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "OccurrenceReminderNodeConnection",
  "kind": "LinkedField",
  "name": "reminders",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OccurrenceReminderNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OccurrenceReminder",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "timing",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "audience",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "emailSubject",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "emailRichEditorBody",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sentAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v36 = [
  (v2/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v35/*: any*/),
      (v27/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isTest",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerIsMember",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSystem",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentMemberGroupId",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v42 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MemberGroupNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MemberGroup",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/),
          (v23/*: any*/),
          (v39/*: any*/),
          (v40/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Product",
            "kind": "LinkedField",
            "name": "product",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          (v41/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MemberGroupNodeConnection",
            "kind": "LinkedField",
            "name": "childrenGroups",
            "plural": false,
            "selections": [
              (v26/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberGroupNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberGroup",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v37/*: any*/),
                      (v38/*: any*/),
                      (v23/*: any*/),
                      (v40/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "product",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v41/*: any*/),
                      (v39/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v44 = [
  (v43/*: any*/)
],
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberPermissions",
  "storageKey": null
},
v46 = [
  {
    "alias": "nonNullProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v43/*: any*/),
  (v45/*: any*/)
],
v47 = [
  {
    "alias": "nullableProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v43/*: any*/),
  (v45/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditEventDrawerContextMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "EditEventResponse",
        "kind": "LinkedField",
        "name": "editEvent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Occurrence",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "OccurrenceMediaNodeConnection",
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OccurrenceMediaNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OccurrenceMedia",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v8/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "media(first:1)"
              },
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "EventAccessFormFields_OrganizationFragment"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "EventMeetingFormFields_OrganizationFragment"
                      }
                    ],
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EventAccessFormFields_ProductFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EventMeetingFormFields_ProductFragment"
                  }
                ],
                "storageKey": null
              },
              (v16/*: any*/),
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingProvider",
                "kind": "LinkedField",
                "name": "meetingProvider",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "OrganizationZoomConnectionListItemFragment"
                  },
                  (v2/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ProfileAvatarWithDetailsFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v20/*: any*/),
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v22/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MemberGroupEventTagListFragment"
                  }
                ],
                "storageKey": null
              },
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductApp",
                "kind": "LinkedField",
                "name": "app",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EventAccessFormFields_AppFragment"
                  }
                ],
                "storageKey": null
              },
              (v32/*: any*/),
              (v33/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "OccurrenceListItemFragment"
              }
            ],
            "storageKey": null
          },
          (v34/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditEventDrawerContextMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "EditEventResponse",
        "kind": "LinkedField",
        "name": "editEvent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Occurrence",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v3/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasViewerBookmarked",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "OccurrenceMediaNodeConnection",
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OccurrenceMediaNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OccurrenceMedia",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          },
                          (v23/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "media(first:1)"
              },
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "platform",
                            "value": "zoom"
                          }
                        ],
                        "concreteType": "MeetingProviderNodeConnection",
                        "kind": "LinkedField",
                        "name": "meetingProviders",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MeetingProviderNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MeetingProvider",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v36/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "meetingProviders(platform:\"zoom\")"
                      },
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "allMemberGroups",
                            "value": true
                          }
                        ],
                        "concreteType": "MemberGroupNodeConnection",
                        "kind": "LinkedField",
                        "name": "memberGroups",
                        "plural": false,
                        "selections": (v42/*: any*/),
                        "storageKey": "memberGroups(allMemberGroups:true)"
                      }
                    ],
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "registrationAvailability",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "kind",
                        "value": "custom"
                      }
                    ],
                    "concreteType": "MemberGroupNodeConnection",
                    "kind": "LinkedField",
                    "name": "memberGroups",
                    "plural": false,
                    "selections": (v42/*: any*/),
                    "storageKey": "memberGroups(kind:\"custom\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cover",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductMembership",
                    "kind": "LinkedField",
                    "name": "viewerMembership",
                    "plural": false,
                    "selections": (v8/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v16/*: any*/),
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingProvider",
                "kind": "LinkedField",
                "name": "meetingProvider",
                "plural": false,
                "selections": (v36/*: any*/),
                "storageKey": null
              },
              (v20/*: any*/),
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v22/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Product",
                    "kind": "LinkedField",
                    "name": "product",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberGroupNodeConnection",
                    "kind": "LinkedField",
                    "name": "memberGroups",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberGroupNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberGroup",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v23/*: any*/),
                              (v40/*: any*/),
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "product",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v37/*: any*/),
                              (v41/*: any*/),
                              (v39/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v26/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v44/*: any*/),
                        "type": "Organization",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "nonNullProductId",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          (v43/*: any*/),
                          (v45/*: any*/)
                        ],
                        "type": "Product",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v46/*: any*/),
                        "type": "Event",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v47/*: any*/),
                        "type": "Comment",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v47/*: any*/),
                        "type": "Feed",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v47/*: any*/),
                        "type": "Post",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "nullableProductIdString",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "productId",
                            "storageKey": null
                          },
                          (v43/*: any*/),
                          (v45/*: any*/)
                        ],
                        "type": "ContentUsage",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v47/*: any*/),
                        "type": "ChatChannel",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v47/*: any*/),
                        "type": "Dashboard",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v46/*: any*/),
                        "type": "AssignmentSubmission",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v44/*: any*/),
                        "type": "PathwayGroup",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v44/*: any*/),
                        "type": "BrainSearch",
                        "abstractKey": null
                      }
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              },
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductApp",
                "kind": "LinkedField",
                "name": "app",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberGroupNodeConnection",
                    "kind": "LinkedField",
                    "name": "visibilityGroups",
                    "plural": false,
                    "selections": (v42/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v32/*: any*/),
              (v33/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isComplete",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasViewerRSVPd",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "atCapacity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserMembershipNodeConnection",
                "kind": "LinkedField",
                "name": "guestReport",
                "plural": false,
                "selections": (v31/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 3
                  }
                ],
                "concreteType": "OccurrenceRSVPNodeConnection",
                "kind": "LinkedField",
                "name": "rsvps",
                "plural": false,
                "selections": [
                  (v26/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OccurrenceRSVPNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OccurrenceRSVP",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v35/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "rsvps(first:3)"
              }
            ],
            "storageKey": null
          },
          (v34/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "901a58dcd71b4d741bd17b18d1f8c520",
    "id": null,
    "metadata": {},
    "name": "EditEventDrawerContextMutation",
    "operationKind": "mutation",
    "text": "mutation EditEventDrawerContextMutation(\n  $input: EditEventInput!\n) {\n  response: editEvent(input: $input) {\n    node {\n      id\n      coverPhoto\n      name\n      richEditorDescriptionContent\n      content {\n        name\n        richEditorDescriptionContent\n        attachments {\n          edges {\n            node {\n              id\n              name\n              mediaUrl\n            }\n          }\n        }\n        coverPhoto\n        id\n      }\n      media(first: 1) {\n        edges {\n          node {\n            id\n          }\n        }\n      }\n      allowGuestAccess\n      status\n      collectFeedback\n      visibility\n      capacity\n      guestCapacity\n      product {\n        id\n        organization {\n          id\n          ...EventAccessFormFields_OrganizationFragment\n          ...EventMeetingFormFields_OrganizationFragment\n        }\n        type\n        ...EventAccessFormFields_ProductFragment\n        ...EventMeetingFormFields_ProductFragment\n      }\n      meetingUrl\n      videoRoomType\n      meetingProvider {\n        ...OrganizationZoomConnectionListItemFragment\n        id\n        zoomConnection {\n          id\n          email\n          firstName\n          lastName\n          picUrl\n          userPlanType\n          hasWebinarAddon\n          meetingCapacity\n          webinarCapacity\n          isConnected\n        }\n        organization {\n          id\n          hasZoomIntegration\n        }\n        user {\n          id\n          ...ProfileAvatarWithDetailsFragment\n        }\n      }\n      zoomRecurringMeetingStatus\n      physicalAddress {\n        displayAddress\n        address\n        lat\n        lng\n        placeId\n        image\n      }\n      event {\n        id\n        productId\n        memberGroupEntityTargets {\n          edges {\n            node {\n              id\n              memberGroup {\n                id\n                kind\n              }\n            }\n          }\n        }\n        isRecurring\n        ...MemberGroupEventTagListFragment\n      }\n      hosts {\n        totalCount\n        edges {\n          node {\n            id\n            user {\n              id\n              first_name: firstName\n              last_name: lastName\n              avatar\n            }\n            productMembershipId\n            organizationMembershipId\n          }\n        }\n      }\n      datetimeRange\n      timezone\n      app {\n        id\n        ...EventAccessFormFields_AppFragment\n      }\n      allRsvps: rsvps {\n        totalCount\n      }\n      reminders {\n        edges {\n          node {\n            id\n            timing\n            audience\n            emailSubject\n            emailRichEditorBody\n            sentAt\n          }\n        }\n      }\n      ...OccurrenceListItemFragment\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n\nfragment BookmarkButtonContentFragment on Content {\n  id\n  hasViewerBookmarked\n}\n\nfragment DeleteOccurrenceButtonFragment on Occurrence {\n  id\n}\n\nfragment EventAccessFormFields_AppFragment on ProductApp {\n  visibility\n  ...MemberGroupsMultiSelect_AppFragment\n}\n\nfragment EventAccessFormFields_OrganizationFragment on Organization {\n  name\n  ...MemberGroupsMultiSelect_OrganizationFragment\n}\n\nfragment EventAccessFormFields_ProductFragment on Product {\n  name\n  registrationAvailability\n  type\n  ...MemberGroupsMultiSelect_ProductFragment\n}\n\nfragment EventMeetingFormFields_OrganizationFragment on Organization {\n  id\n  meetingProviders(platform: zoom) {\n    edges {\n      node {\n        id\n        ...OrganizationZoomConnectionListItemFragment\n      }\n    }\n  }\n}\n\nfragment EventMeetingFormFields_ProductFragment on Product {\n  id\n  organization {\n    meetingProviders(platform: zoom) {\n      edges {\n        node {\n          id\n          ...OrganizationZoomConnectionListItemFragment\n        }\n      }\n    }\n    id\n  }\n  ...OccurrencePhysicalAddressInput_ProductFragment\n}\n\nfragment MemberGroupEventTagListFragment on Event {\n  id\n  product {\n    type\n    id\n  }\n  memberGroups {\n    edges {\n      node {\n        id\n        kind\n        parentMemberGroupId\n        name\n        product {\n          name\n          id\n        }\n        ...MemberGroupTagFragment\n      }\n    }\n  }\n}\n\nfragment MemberGroupTagFragment on MemberGroup {\n  id\n  name\n  kind\n  color\n  role\n  isSystem\n  product {\n    id\n    name\n  }\n}\n\nfragment MemberGroupsMultiSelect_AppFragment on ProductApp {\n  id\n  visibilityGroups {\n    edges {\n      node {\n        id\n        name\n        color\n        viewerIsMember\n        kind\n        isSystem\n        parentMemberGroupId\n        visibility\n        product {\n          id\n          name\n          type\n        }\n        ...MemberGroupTagFragment\n        childrenGroups {\n          totalCount\n          edges {\n            node {\n              id\n              name\n              color\n              viewerIsMember\n              kind\n              parentMemberGroupId\n              visibility\n              product {\n                id\n                name\n              }\n              ...MemberGroupTagFragment\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment MemberGroupsMultiSelect_OrganizationFragment on Organization {\n  memberGroups(allMemberGroups: true) {\n    edges {\n      node {\n        id\n        name\n        color\n        viewerIsMember\n        kind\n        isSystem\n        parentMemberGroupId\n        visibility\n        product {\n          id\n          name\n          type\n        }\n        ...MemberGroupTagFragment\n        childrenGroups {\n          totalCount\n          edges {\n            node {\n              id\n              name\n              color\n              viewerIsMember\n              kind\n              parentMemberGroupId\n              visibility\n              product {\n                id\n                name\n              }\n              ...MemberGroupTagFragment\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment MemberGroupsMultiSelect_ProductFragment on Product {\n  id\n  memberGroups(kind: custom) {\n    edges {\n      node {\n        id\n        name\n        color\n        viewerIsMember\n        kind\n        isSystem\n        parentMemberGroupId\n        visibility\n        product {\n          id\n          name\n          type\n        }\n        ...MemberGroupTagFragment\n        childrenGroups {\n          totalCount\n          edges {\n            node {\n              id\n              name\n              color\n              viewerIsMember\n              kind\n              parentMemberGroupId\n              visibility\n              product {\n                id\n                name\n              }\n              ...MemberGroupTagFragment\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment OccurrenceAttendingButtonFragment on Occurrence {\n  id\n  product {\n    id\n    slug\n    type\n  }\n}\n\nfragment OccurrenceListItemFragment on Occurrence {\n  id\n  name\n  datetimeRange\n  coverPhoto\n  status\n  isComplete\n  visibility\n  appId\n  hosts {\n    totalCount\n  }\n  product {\n    id\n    cover\n    type\n    name\n    slug\n    status\n  }\n  event {\n    id\n    ...MemberGroupEventTagListFragment\n    ...usePermissionsFragment\n    memberGroups {\n      totalCount\n    }\n  }\n  content {\n    id\n    hasViewerBookmarked\n    ...BookmarkButtonContentFragment\n  }\n  ...OccurrenceNameAndTimeFragment\n  ...OccurrenceRSVPAttendanceStatusFragment\n  ...OccurrenceStatusChipFragment\n  ...OccurrenceWatchVideoButtonFragment\n  ...DeleteOccurrenceButtonFragment\n  guestReport {\n    totalCount\n  }\n  rsvps(first: 3) {\n    totalCount\n    edges {\n      node {\n        id\n        user {\n          fullName\n          id\n        }\n      }\n    }\n  }\n  media(first: 1) {\n    edges {\n      node {\n        id\n        url\n        kind\n      }\n    }\n  }\n}\n\nfragment OccurrenceNameAndTimeFragment on Occurrence {\n  id\n  name\n  datetimeRange\n  event {\n    isRecurring\n    id\n  }\n}\n\nfragment OccurrencePhysicalAddressInput_ProductFragment on Product {\n  id\n}\n\nfragment OccurrenceRSVPAttendanceStatusFragment on Occurrence {\n  id\n  product {\n    id\n    slug\n    type\n  }\n  ...RSVPToEventButtonFragment\n  ...occurrenceUtils_useOccurrenceStatusFragment\n  ...OccurrenceRegisterAndRSVPButtonFragment\n  ...OccurrenceAttendingButtonFragment\n}\n\nfragment OccurrenceRegisterAndRSVPButtonFragment on Occurrence {\n  id\n  product {\n    id\n    slug\n    type\n  }\n}\n\nfragment OccurrenceStatusChipFragment on Occurrence {\n  id\n  datetimeRange\n  ...occurrenceUtils_useOccurrenceStatusFragment\n}\n\nfragment OccurrenceWatchVideoButtonFragment on Occurrence {\n  id\n  ...occurrenceUtils_useOccurrenceStatusFragment\n}\n\nfragment OrganizationZoomConnectionListItemFragment on MeetingProvider {\n  id\n  zoomConnection {\n    id\n    email\n    firstName\n    lastName\n    picUrl\n    userPlanType\n    hasWebinarAddon\n    meetingCapacity\n    webinarCapacity\n    isConnected\n  }\n  organization {\n    id\n    hasZoomIntegration\n  }\n  user {\n    id\n    ...ProfileAvatarWithDetailsFragment\n  }\n}\n\nfragment ProfileAvatarFragment on User {\n  id\n  fullName\n  avatar\n  isTest\n}\n\nfragment ProfileAvatarWithDetailsFragment on User {\n  id\n  fullName\n  ...ProfileAvatarFragment\n}\n\nfragment RSVPToEventButtonFragment on Occurrence {\n  id\n  status\n  hasViewerRSVPd\n  capacity\n  atCapacity\n  event {\n    id\n    isRecurring\n  }\n}\n\nfragment occurrenceUtils_useOccurrenceStatusFragment on Occurrence {\n  id\n  datetimeRange\n  hasViewerRSVPd\n  timezone\n  product {\n    viewerMembership {\n      id\n    }\n    id\n  }\n  media(first: 1) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  event {\n    ...usePermissionsFragment\n    id\n  }\n}\n\nfragment usePermissionsFragment on Node {\n  __isNode: __typename\n  __typename\n  ... on Organization {\n    viewerPermissions\n  }\n  ... on Product {\n    nonNullProductId: id\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Event {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Comment {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Feed {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Post {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ContentUsage {\n    nullableProductIdString: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ChatChannel {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Dashboard {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on AssignmentSubmission {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on PathwayGroup {\n    viewerPermissions\n  }\n  ... on BrainSearch {\n    viewerPermissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "0d57300a4b0899816be11ed8b80fb9ab";

export default node;
